var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPalette = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0m2 2.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2M7 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0m2 .5a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M5.417 2.264A6.75 6.75 0 0 1 14.75 8.5a.75.75 0 0 1-.75.75h-1.3a5.75 5.75 0 0 1-5.7 5A5.75 5.75 0 0 1 1.25 8.5a6.75 6.75 0 0 1 4.167-6.236M11.25 8.5a.75.75 0 0 1 .75-.75h1.196a5.26 5.26 0 0 0-3.187-4.1A5.25 5.25 0 0 0 2.75 8.5a4.25 4.25 0 1 0 8.5 0",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPalette);
export default ForwardRef;